import { useFormContext } from 'react-hook-form';
import { Textarea, TextareaProps } from '../components';
import { FormField } from './BaseFormComponents';
import { BaseFormFieldWrapper } from './BaseFormFieldWrapper';
import { FormComponentBaseProps } from './types/form-base-props';

export type FormTextareaProps = FormComponentBaseProps &
  TextareaProps & {
    formatValue?: (value: string) => string | null;
    counter?: {
      max: number;
    };
  };

const FormTextarea = ({
  formatValue,
  description,
  descriptionProps,
  label,
  counter,
  labelProps,
  hideError,
  defaultValue,
  name,
  disabled,
  ...props
}: FormTextareaProps) => {
  const { control } = useFormContext();

  return (
    <FormField
      shouldUnregister={false}
      disabled={disabled}
      name={name}
      defaultValue={defaultValue}
      control={control}
      render={({ field }) => (
        <BaseFormFieldWrapper
          description={description}
          descriptionProps={descriptionProps}
          label={
            counter ? (
              <div className="flex items-start justify-between gap-2">
                <label className="text-primary text-sm leading-[18px] font-medium">
                  {label}
                </label>
                <span className="text-primary font-base text-sm leading-[18px]">
                  <span>{String(field.value || '').length}/</span>
                  <span className="text-muted-foreground">{counter.max}</span>
                </span>
              </div>
            ) : (
              label
            )
          }
          labelProps={labelProps}
          hideError={hideError}
        >
          <Textarea
            {...field}
            value={String(
              (formatValue ? formatValue(field.value) : field.value) ?? ''
            )}
            {...props}
          />
        </BaseFormFieldWrapper>
      )}
    />
  );
};

export { FormTextarea };
